import { expertPhrase } from './categoryPhrase';
// @ts-ignore — plain-JS composer shared with scripts/wa-worker.mjs
import { visitorLeadMessage } from './leadMessage.mjs';
import { ticketRefLine } from './heMsg.mjs';
import { currentGreeting } from './eveningClient';
// Message text for the new company-WhatsApp lead-gen surfaces (972506403800) — separate
// from lib/waMessage.ts's per-pro message builder since these never target a specific pro
// and always end with a ticket number for manual/future matching (explicit user request).
export function buildInquiryMessage(opts: {
  categoryName?: string | null;
  city?: string | null;
  needClause?: string | null;
  ticketNo?: string | null;
  topic?: string | null;
  greeting?: string | null; // explicit (server routes); the browser default is the evening greeting (lib/eveningClient.ts)
}): string {
  const { categoryName, city, needClause, ticketNo, topic } = opts;
  const greeting = opts.greeting !== undefined ? opts.greeting : currentGreeting();
  // NEW FLOW (Founder 2026-09-25): the ONE wording for a questionnaire lead, also on the fallback path (bughunter: a 429 on
  // /api/wa-links used to ship the retired "#ticket" format). No links, no '#', ticket only as "מספר פנייה".
  if (process.env.NEXT_PUBLIC_WA_NEW_FLOW === '1' || process.env.WA_NEW_FLOW === '1') {
    // Founder 2026-09-27: "עם שמאי מקרקעין" for a professional, "עם מומחה לסגירת מרפסת" for a service (lib/categoryPhrase.ts);
    // 2026-09-28: the Hebrew-correct composer (lib/leadMessage.mjs) — "לגבי" only before a noun-phrase detail, city as "ב<עיר>".
    return visitorLeadMessage({ categoryName, expertNoun: categoryName ? expertPhrase(categoryName) : 'מומחה', need: needClause, city, ticket: ticketNo, topic, greeting }) as string;
  }
  const parts: string[] = [];
  if (needClause) {
    parts.push(needClause);
  } else if (categoryName) {
    parts.push(`היי, אשמח לקבל עזרה מ${categoryName}`);
  } else {
    parts.push('היי, אשמח לקבל ייעוץ מהמומחים');
  }
  if (city) parts.push(`אני מ${city}`);
  let msg = parts.join(' · ');
  if (ticketNo) msg += /^C\d+$/.test(ticketNo) ? ticketRefLine(ticketNo) : `\n\n${ticketRefLine(ticketNo)}`; // click = invisible mark glued to the text (06/10); never a raw "#C4" (patrol 05/10)
  return msg;
}
